export default "__VITE_ASSET__3AUXaNqA__"